import { LoginForm } from '@/components/auth/loginForm';
import { CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/_auth/(login)/login')({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation();

  return (
    <>
      <CardHeader className="gap-space-2xs">
        <CardTitle className="text-heading-lg-semibold">{ t('login.title', { ns: 'auth' }) }</CardTitle>
        <CardDescription className="text-body-md-normal">{ t('login.description', { ns: 'auth' }) }</CardDescription>
      </CardHeader>

      <CardContent className="pt-space-lg">
        <LoginForm />
      </CardContent>
    </>
  );
}
